<div>
  <div class="search-form" [ngClass]="isAccountFilter ? 'account-filter' : ''">
    <div class="account-search-bar">
      <input
        #searchInput
        #trigger="cdkOverlayOrigin"
        (focusin)="handleFocus($event)"
        (input)="handleInput($event)"
        (keydown)="handleKeydown($event)"
        (blur)="checkIfAccountIsBlank()"
        autocomplete="off"
        cdk-overlay-origin
        class="client-search sdps-input"
        [ngClass]="{
          'ag-text-field-input': isAccountFilter,
          'input-background-active': selectedValue && !searchInput.disabled && !viewMode && !isMasterAccountSearch
        }"
        type="text"
        [value]="selectedValue ? selectedValue : ''"
        placeholder="" />
        <span>
          @if (searchInput.value.length > 2 && !searchInput.disabled) {
            <i
              class="sdps-text-secondary delete-icon-padding"
              (click)="clearAccount()"
              ><img class="deleteIcon" [src]="deleteIcon" /></i
              >
          }</span>
          <span>
            @if (searchInput.value.length < 3 && !searchInput.disabled) {
              <i
                class="sch-search sdps-text-secondary search-icon-padding"
                ></i
                >
              }</span>
            </div>

            <ng-template
              [cdkConnectedOverlayOpen]="showPanel"
              [cdkConnectedOverlayOrigin]="trigger"
              [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
              [cdkConnectedOverlayPositions]="positions"
              cdkConnectedOverlay>
              <div class="account-search-container">
                <!--<div class="account-search-header"></div>-->
                <div class="scroll-container" style="min-height: 200px" [ngStyle]="{ 'max-height.px': panelHeight }">
                  <div class="search-content">
                    <div #panel [ngClass]="isLoading ? 'default' : ''" class="search-panel" [ngStyle]="{ 'width.px': width }">
                      <sch-spinner #spinner type="loading"> </sch-spinner>
                      @if (!isLoading) {
                        @if (statusMessage) {
                          <div class="error">{{ statusMessage }}</div>
                        }
                        @if (!filteredAccounts.length && searchCriteria.searchTerm !== '' && !isLoading) {
                          <ng-container *ngTemplateOutlet="noSearchResultsFound"></ng-container>
                        }
                        <div class="clients-accounts">
                          <ul>
                            <li>
                              @if (
                                (!filteredAccounts.length && searchCriteria.searchTerm !== '' && !isLoading) ||
                                (searchCriteria.searchTerm === '' && !isLoading)
                                ) {
                                <hr
                                  />
                              }
                            </li>
                            <li>
                              @if (filteredAccounts.length) {
                                <ng-container *ngTemplateOutlet="accountsTemplate"></ng-container>
                              }
                            </li>
                          </ul>
                        </div>
                      }
                    </div>
                  </div>
                </div>
                <!--<div class="account-search-footer"></div>-->
              </div>
            </ng-template>

            <ng-template #noSearchResultsFound>
              <div class="no-results-header">
                <p>No results</p>
                <br />
              </div>
            </ng-template>
            <ng-template #accountsTemplate>
              <div>
                <table class="account-search-results-table">
                  <tbody>
                    @for (account of filteredAccounts; track account; let i = $index) {
                      <tr
                        (selected)="select(account)"
                        [type]="accountRecordType"
                        [value]="account"
                        search-result-row>
                        <div class="col top-row">
                          <td
                            class="id sdps-text-primary sdps-text-body"
                          [innerHtml]="account.accountId | accountNumber | highlight: searchCriteria.searchTerm : 'account'"></td>
                          @if (!isMasterAccountSearch) {
                            <td
                              class="type sdps-text-secondary sdps-text-body"
                            [innerHTML]="account.type"></td>
                          }
                        </div>
                        <div class="col bottom-row">
                          <td
                            class="desc sdps-text-primary sdps-text-body"
                          [innerHtml]="account.accountName | highlight: searchCriteria.searchTerm"></td>
                        </div>
                        <div class="bottom-border"></div>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            </ng-template>
          </div>
        </div>
